module.exports = __webpack_public_path__ + "img/暂无任何数据.5dd62e97.png";